import { Conductor } from "src/models";

export type ArchiveList = {
    loading: boolean;
    offset: number;
    count: number;
    hasMore: boolean;
    searchText: string;
    list: Conductor[];
    totalRecords: number;
    firstLoad: boolean;
};

export const ArchiveListInitialState: ArchiveList = {
    loading: false,
    offset: 0,
    count: 20,
    hasMore: true,
    searchText: "",
    list: [],
    totalRecords: 0,
    firstLoad: true
};